var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeterinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0908 2.5304H32.4995V7.27489H37.7184V16.2104C37.7184 24.0586 31.333 30.444 23.4848 30.444C15.6366 30.444 9.25133 24.0587 9.25133 16.2105V7.27489H14.3122V2.5304H6.87908C5.5688 2.5304 4.50684 3.59236 4.50684 4.90264V16.2105C4.50684 26.6754 13.0201 35.1886 23.4849 35.1886C33.9498 35.1886 42.463 26.6754 42.463 16.2105V4.90264C42.463 3.59236 41.4011 2.5304 40.0908 2.5304Z",
    fill: "#88CCDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3427 37.1654V48.3941C49.3427 54.9345 44.0217 60.2555 37.4813 60.2555C30.941 60.2555 25.62 54.9345 25.62 48.3941V32.8953H20.8755V48.3941C20.8755 57.5503 28.3243 65 37.4813 65C46.6375 65 54.0872 57.5503 54.0872 48.3941V37.1654H49.3427Z",
    fill: "#88CCDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7157 21.8248C46.8747 21.8248 42.9375 25.762 42.9375 30.6022C42.9375 35.4416 46.8747 39.3796 51.7149 39.3796C56.5551 39.3796 60.4923 35.4416 60.4931 30.6022C60.493 25.762 56.5551 21.8248 51.7157 21.8248ZM51.7149 34.6351C49.4906 34.6351 47.6812 32.8259 47.6812 30.6023C47.6812 28.3787 49.4904 26.5695 51.7149 26.5695C53.9385 26.5695 55.7477 28.3787 55.7477 30.6023C55.7477 32.8259 53.9385 34.6351 51.7149 34.6351Z",
    fill: "#88CCDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2331 0C12.9228 0 11.8608 1.06196 11.8608 2.37225V7.43311C11.8608 8.74339 12.9228 9.80535 14.2331 9.80535C15.5434 9.80535 16.6053 8.74339 16.6053 7.43311V2.37225C16.6053 1.06196 15.5434 0 14.2331 0Z",
    fill: "#88CCDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5788 0C31.2685 0 30.2065 1.06196 30.2065 2.37225V7.43311C30.2065 8.74339 31.2685 9.80535 32.5788 9.80535C33.8891 9.80535 34.951 8.74339 34.951 7.43311V2.37225C34.951 1.06196 33.8891 0 32.5788 0Z",
    fill: "#88CCDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinary);
export default __webpack_public_path__ + "static/media/veterinary.74380ca4d6a8febded1e8460dd8e45dd.svg";
export { ForwardRef as ReactComponent };